import React from 'react';
import ServerlessInferenceCosts from './ServerlessInferenceCosts';

const ServerlessInferenceDashboard = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-cf-gray-900 mb-2">GenAI / Serverless Inference Costs</h1>
        <p className="text-sm text-cf-gray-600">View and analyze your serverless inference costs by model and month across all invoices.</p>
      </div>

      <ServerlessInferenceCosts />
    </div>
  );
};

export default ServerlessInferenceDashboard;
